import { get } from "lodash";

const getFreezeEventsHasFetched = state => {
  const id = get(state, "factoringClient.id", "");
  if (!id) {
    return false;
  }
  const map = get(state, "factoringClient.freezeEvents", {});
  return Object.prototype.hasOwnProperty.call(map, id);
};

export default getFreezeEventsHasFetched;
